






import { Component, Prop, Vue } from 'vue-property-decorator';
import { TimeSpan } from '@/models/CalendarEntries';
import { MeetingCalendarStore } from '@/store/meetingcalendarstate';
@Component
export default class CalendarTime extends Vue {
    @Prop() private data!: TimeSpan;

    get label(): string {
        const startTime = this.data.startDate.split('T')[1].slice(0, -3);
        const endTime = this.data.endDate.split('T')[1].slice(0, -3);
        return startTime + ' - ' + endTime;
    }
    get classObject(): any {
        return {
            selected: this.isSelectedTimeSpan,
            filtered: this.data.disabled
        };
    }
    get isSelectedTimeSpan(): boolean {
        if (MeetingCalendarStore.getSelectedMeetingTimeSpan === null) {
            return false;
        }
        return MeetingCalendarStore.getSelectedMeetingTimeSpan.startDate === this.data.startDate;
    }
    private handleClick() {
        if (this.data.disabled) {
            MeetingCalendarStore.setSelectedMeetingPerson(undefined);
        }
        if (this.isSelectedTimeSpan) {
            MeetingCalendarStore.setSelectedMeetingTimeSpan(null);
        } else {
            MeetingCalendarStore.setSelectedMeetingTimeSpan(this.data);
        }
    }
}
